"use client";

import { useEffect, useState } from 'react';

export function useDeferredMount() {
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setShouldMount(true);
      });
    });
  }, []);

  return shouldMount;
}
